var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39922 8.89995H8.89922V8.39995V3.29995C8.89922 3.24473 8.94399 3.19995 8.99922 3.19995C9.05444 3.19995 9.09922 3.24473 9.09922 3.29995V8.39995V8.89995H9.59922H14.6992C14.7544 8.89995 14.7992 8.94475 14.7992 8.99995C14.7992 9.05515 14.7544 9.09995 14.6992 9.09995H9.59922H9.09922V9.59995V14.7C9.09922 14.7552 9.05442 14.8 8.99922 14.8C8.94402 14.8 8.89922 14.7552 8.89922 14.7V9.59995V9.09995H8.39922H3.29922C3.24399 9.09995 3.19922 9.05518 3.19922 8.99995C3.19922 8.94473 3.24399 8.89995 3.29922 8.89995H8.39922Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.427efca774755299007a7e4f34e2ad1a.svg";
export { ForwardRef as ReactComponent };